import { Component, OnInit, Input } from '@angular/core';
import { OfferService } from '../../../shared/providers/offer.service';
import { ValidationService } from '../../../shared/providers/validation.service';
import { IChartData, InnerData } from '../../../shared/models/IChartData';
import { Chart } from 'highcharts';
import { LoaderService } from '../../../shared/providers/loader.service';
import { SharedService } from '../../../shared/providers/shared.service';
import { TaskStatus } from '../../../shared/enum/enum';
import * as Highcharts from 'highcharts';
declare var require: any;
//require('highcharts/modules/map')(Highcharts);
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}

export class Category {
    name: string;
    categories: string[];
}


@Component({
    selector: 'app-offer-progress-tab',
    templateUrl: './offer-progress-tab.component.html',
    styleUrls: ['./offer-progress-tab.component.css']
})

export class OfferProgressTabComponent implements OnInit {

    @Input() inputOfferGuid: string = "";
    constructor(private offerService: OfferService, public Validation: ValidationService, private Loader: LoaderService, private Shared: SharedService) {
    }

    offerGuid = '';
    chartDataReesponse: IChartData[];
    chartData = [];
    chartContent = ['', ''];
    //chartProgress = new Chart();
    taskStatus = TaskStatus;
    startDate: number = 0;
    endDate: any;
    currentDate: any;
    date_45: any;
    Aday: number = 24 * 3600 * 1000;

    options: Object;
    private chartLabelOptions = {
        style: {
          fontSize: '12px'
        }
      };
    ngOnInit() {
        //Below code will execute any of the task details edited from task tab in offer detail page
        this.Shared.offerPageReloadStatus.subscribe(res => {
            this.bindChart();
        });
    }

    bindChart() {
      
        this.offerGuid = this.inputOfferGuid;
        this.currentDate = this.Validation.getCurrentDate();
        //this.chartProgress = new Chart();
        this.chartDataReesponse = [];
        this.chartData = [];
        this.chartContent = ['', ''];
        this.offerService.GetOfferProgressChartData(this.offerGuid).subscribe(res => {
            this.chartDataReesponse = res;
            let count = 1;
            this.endDate = 0;

            this.chartDataReesponse.forEach(item => {

                let highdate = 0;
                highdate = this.Validation.convertDateToUTCStamp(new Date(item.EndDate));

                let lowDate = 0;
                lowDate = this.Validation.convertDateToUTCStamp(new Date(item.StartDate));

                let HoverText = "Start Date :" + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(item.StartDate))) +
                    " End Date :" + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(item.EndDate)));
                //if (item.Id !== 0) {
                //    this.chartContent.push(item.Name);
                //}
                //else {
                //    this.chartContent.push('');
                //}
                this.chartContent.push(item.Name);
                if (this.startDate === 0) {
                    this.startDate = lowDate;
                }
                if (this.startDate > lowDate) {
                    this.startDate = lowDate;
                }

                if (this.endDate < highdate) {
                    this.endDate = highdate;
                }

                count++;

                const singleData = {
                  name: item.Id == 0 ? this.Validation.getTaskPhaseName(item.PhaseId, item.Name) : item.Name,
                  color: this.getChartColor(item.PhaseId, item.OfferStatus),
                    //color: item.Id == 0 ? '#66ccff' : this.colorPicker(lowDate, highdate, item.StatusId),
                    pointWidth: 25,
                    data: [{
                        x: count,
                        low: lowDate,
                        high: highdate,
                        hoverText: HoverText
                    }],
                    dataLabels: {
                        enabled: true,
                        x: -5
                    }
                };
                this.chartData.push(singleData);
            });
            this.date_45 = this.startDate + (this.Aday * 45)
          Highcharts.chart('chartdiv',{
            chart: {
              renderTo:'chartdiv',
                    type: 'columnrange',
                    inverted: true
                },
                title: {
                    text: ""
                },
                xAxis: {
                    categories: this.chartContent,
                    type: 'category',
                    //visible: true,
                    title: {
                        text: ''
                    },
                    labels: this.chartLabelOptions
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    type: 'datetime',
                    min: this.startDate,
                    max: this.endDate,
                    tickInterval: this.Aday * 10,
                    dateTimeLabelFormats: {
                        day: '%e %b %y'
                    },
                    labels: {
                        format: '{value:%b-%e}',
                        style: {
                            fontSize: '12px'
                        },
                        //'{value:%Y-%b-%e}'
                    },
                    
                    plotBands: [{
                        color: '#0099ff',
                        from: this.currentDate,
                        to: this.currentDate,
                        label: {
                            text: '<b>Today<b> <br>' + (this.Validation.IsinValid(this.currentDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.currentDate)))),
                            align: this.setCurrentDatePosition(this.currentDate, this.endDate, this.currentDate) ? 'right' : 'left',
                            x: this.setCurrentDatePosition(this.currentDate, this.endDate, this.currentDate) ? -5 : 5,
                            y: 750,
                            style: {
                                fontSize: '12px'
                            },
                        },

                        
                    },
                    //    {
                    //    color: '#bd2765',
                    //    from: this.date_45,
                    //    to: this.date_45 + (24 * 3600 * 75 * 1),
                    //    label: {
                    //        text: '<b>45 Days</b><br>' + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.date_45))),
                    //        align: 'right',
                    //        style: {
                    //            fontSize: '11px',
                    //        }
                    //    }
                    //},
                    {
                        color: 'red',
                        from: this.endDate,
                        to: this.endDate,
                        label: {
                            text: '<b>Closing Date</b><br>' + (this.Validation.IsinValid(this.endDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.endDate)))),
                            align: 'right',
                            x: -5,
                            style: {
                                fontSize: '12px',
                                whiteSpace: 'nowrap',
                                overflow: 'visible',
                                textOverflow: 'none',
                            }
                        }
                    }],
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    columnrange: {
                        grouping: false,
                        borderRadius: 8
                    },

                    series: {
                        stacking: 'normal',
                        cursor: 'pointer',
                        stickyTracking: false,
                        events: {
                            legendItemClick: function () {
                                return false;
                            },
                            click: function (event) {
                                return false;
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            align: 'center',
                            color: '#000000',
                            x: -10,
                            formatter: function () {
                                if (this.series.name.split('-').length >= 2) {
                                    return '<b>' + this.series.name.split('-')[0] + '</b>';
                                }
                                else {
                                    return '';
                                }
                            }
                        }
                    },
                },
                series: this.chartData,
                exporting: {
                    enabled: false
                }, credits: {
                    enabled: false
                },
                tooltip: {
                    formatter: function () {
                        let index = this.series.data.indexOf(this.point);
                        return '<b>' + this.series.name + '</b> <br>' + this.series.data[index]["hoverText"]//.hoverText
                    },
                    borderWidth: 2,
                }
            });
        });
    }
    setCurrentDatePosition(startDate: number, endDate: number, currentDate: number) {
        if ((endDate - currentDate) <= 172800000) {
            return true;
        }
        return false;
  }

  getChartColor(phaseid, offerStatus) {
    if (offerStatus == 467 || offerStatus == 466) {
      return ' #59595B ';
    }
    const colors = [' #A7A8A9 ', ' #003A5D ', ' #02C29F ', ' #FFC32B ', ' #FF4438 ']
    switch (phaseid) {
      case 2300: {
        return colors[0];
      }
      case 2301: {
        return colors[1];
      }
      case 2302: {
        return colors[2];
      }
      case 2303: {
        return colors[3];
      }
      case 2304: {
        return colors[4];
      }
      case 350: {
        return "#5bc7af";
      }
      default: {
        return "#5bc7af";
      }
    }
  }

    colorPicker(lowdate: any, highdate: any, statusId: number) {
        if (statusId !== TaskStatus.Completed && (this.currentDate > highdate)) {
            return "#F05F5F";
        }
        if (statusId == TaskStatus.New) {
            return "#cccccc";
        }
        else if (statusId == TaskStatus.InProgress) {
            return "#efc36d";
        }
        else{
            return "#5bc7af";
        }
        //if (this.currentDate > highdate) {
        //    return "#5bc7af";
        //}
        //else if ((this.currentDate <= highdate) && (this.currentDate >= lowdate)) {
        //    return "#efc36d";
        //}
        //else if (this.currentDate < highdate) {
        //    return "#cccccc";
        //}
    }
}
